import { render, staticRenderFns } from "./WorkIconDocumentPlus.vue?vue&type=template&id=12d5abd0"
import script from "./WorkIconDocumentPlus.vue?vue&type=script&lang=js"
export * from "./WorkIconDocumentPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports